import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { Urls } from "../../../utils/constant";

import { size, debounce } from "lodash";

import { minWidth } from "@mui/system";
import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setDoctorList } from "../../reducers/Doctor/doctor.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";

const COLUMN_LIST = [
  // { field: "customer_id", headerName: "ID", hide: true },
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "name",
    headerName: "Doctor Name",

    flex: 2,
  },
  {
    field: "speciality",
    headerName: "Speciality",

    flex: 2,
  },
  {
    field: "experience",
    headerName: "Experience",

    flex: 1,
  },
  // {
  //   field: "biography",
  //   headerName: "Biography",

  //   flex: 1,
  // },
  // {
  //   field: "location_url",
  //   headerName: "Location",

  //   flex: 2,
  // },

  {
    field: "slot_timing",

    headerName: "Slot Timing(In Min)",

    flex: 1,
  },
  {
    field: "working_time",
    headerName: "Working Time",

    flex: 3,
  },

  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useDoctor() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [Name, setName] = useState("");
  const [Speciality, setSpeciality] = useState("");
  const [status, setStatus] = useState(1);
  const fetchDoctorList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.doctorGet(),
          data: {
            id: "",
            name: Name,
            speciality: Speciality,
            page_size: row_count,
            current_page: current_page,
            status: StatusVal,
          },
        });
        // setting list to reducer
        dispatch(setDoctorList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status, Name, Speciality]
  );

  const handleNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const handleSpecialityChange = useCallback((e) => {
    setSpeciality(e.target.value);
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    Name,
    handleNameChange,
    handleStatusChange,
    handleSpecialityChange,
    fetchDoctorList,
    Speciality,
  };
}
